export const InstallHero = {
  flow: 'y',
  theme: 'headerCaptions',
  flow: 'column',
  gap: 'C1',
  padding: 'D3+Z D3 0',
  margin: '-D3+Z -D3 0',
  minWidth: '100%',
  Hgroup: {
    H: {
      text: 'Install Symbols',
    },
    P: {
      text: 'The short block to get your Symbols integrated:',
    },
  },
  'Iframe.youtube': {
    widthRange: 'G 50%',
    src: 'https://www.youtube.com/embed/QIdimVDuSEU?si=-1m28wkdUypmrI0w',
    border: '0',
    round: 'X2',
    margin: '-A -X2 -D3',
    aspectRatio: '16 / 9',
    minHeight: '0',
    allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
    allowfullscreen: true,
    onBeforeUpdate: () => false,
  },
};